import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./_modules/auth/auth.module')
      .then(m => m.AuthModule)
  }, {
    path: 'console/admin/manage',
    loadChildren: () => import('./_modules/manage-feature/manage-feature.module')
      .then(m => m.ManageFeatureModule)
  }, {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
